module.exports = __webpack_public_path__ + "static/img/m10.430d71c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/mobile/m10.png
// module id = XkcJ
// module chunks = 12